import React from "react";
import { CircleAlert } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

export type StatisticsPageErrorBannerProps = {
  message: string;
  action?: string;
  title?: string;
  onRetry?: () => void;
  retryLabel?: string;
  className?: string;
};

export function StatisticsPageErrorBanner({
  message,
  action,
  title = "Couldn't load statistics",
  onRetry,
  retryLabel = "Try again",
  className,
}: StatisticsPageErrorBannerProps): React.ReactElement {
  return (
    <Alert variant="error" className={className ?? "mb-4 rounded-xl"}>
      <CircleAlert />
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0 flex-1">
          <AlertTitle className="font-[family-name:var(--font-primary,'Urbanist',sans-serif)]">
            {title}
          </AlertTitle>
          <AlertDescription>
            <p>{message}</p>
            {action ? <p className="mt-1 text-muted-foreground">{action}</p> : null}
          </AlertDescription>
        </div>
        {onRetry ? (
          <Button type="button" variant="outline" size="sm" onClick={onRetry} className="shrink-0">
            {retryLabel}
          </Button>
        ) : null}
      </div>
    </Alert>
  );
}
